import {match} from 'ts-pattern';

import {isNil, isNotNil} from 'ramda';

import type {Nullish} from 'shared/web';

export function getArticleSellingPriceWarning(
  sellingPriceWithoutVat: number | Nullish,
  averagePurchasePriceWithoutVat: number | Nullish,
  lastPurchasePriceWithoutVat: number | Nullish
) {
  if (isNil(sellingPriceWithoutVat)) {
    return undefined;
  }

  const isBelowAverage =
    isNotNil(averagePurchasePriceWithoutVat) &&
    sellingPriceWithoutVat < averagePurchasePriceWithoutVat;
  const isBelowLast =
    isNotNil(lastPurchasePriceWithoutVat) && sellingPriceWithoutVat < lastPurchasePriceWithoutVat;

  return match([isBelowAverage, isBelowLast])
    .with(
      [true, true],
      () => 'entity.warehouse.notifications.sellingPriceBelowAverageAndLastPurchasePrice' as const
    )
    .with(
      [true, false],
      () => 'entity.warehouse.notifications.sellingPriceBelowAveragePurchasePrice' as const
    )
    .with(
      [false, true],
      () => 'entity.warehouse.notifications.sellingPriceBelowLastPurchasePrice' as const
    )
    .otherwise(() => undefined);
}
